import { useEffect } from "react";

/**
 * Emits generic screen-entered events while a guided tour is active.
 * Tour steps can wait for these events without the engine knowing about screens.
 */
export function TourScreenSignalBridge({ screen, isGuidedModeActive }) {
  useEffect(() => {
    if (!isGuidedModeActive || !screen) {
      return;
    }

    window.dispatchEvent(new CustomEvent(`cp-tour-screen-${screen}`));
  }, [screen, isGuidedModeActive]);

  return null;
}
